import { render, staticRenderFns } from "./resume-pricing.vue?vue&type=template&id=929e2dca&scoped=true&"
import script from "./resume-pricing.vue?vue&type=script&lang=js&"
export * from "./resume-pricing.vue?vue&type=script&lang=js&"
import style0 from "./resume-pricing.vue?vue&type=style&index=0&id=929e2dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929e2dca",
  null
  
)

export default component.exports